import standardBedroom from './images/standard_bedroom.png'
import extraLargeBedroom from './images/extra_large_bedroom.png'
import standardLivingRoom from './images/standard_living_room.png'
import extraLargeLivingRoom from './images/extra_large_living_room.png'
import formalDining from './images/formal_dining.png'
import nook from './images/nook.png'
import officeSpace from './images/office_space.png'
import outdoorDining from './images/outdoor_dining.png'
import outdoorLounge from './images/outdoor_lounge.png'


export const serviceTypeMap = {
  staging: 'Staging',
  residential: 'Residential Interior Design',
  commercial: 'Commercial Design'
}

export const stagingItem = {
  standardBedroom: {
    image: standardBedroom,
    price: '550',
    description: 'Standard bedroom set'
  },
  extraLargeBedroom: {
    image: extraLargeBedroom,
    price: '750',
    description: 'Extra-large bedroom set'
  },
  standardLivingRoom: {
    image: standardLivingRoom,
    price: '550',
    description: 'Standard living room set'
  },
  extraLargeLivingRoom: {
    image: extraLargeLivingRoom,
    price: '750',
    description: 'Extra-large living room set'
  },
  formalDining: {
    image: formalDining,
    price: '550',
    description: 'Formal dining set for 6 people'
  },
  nook: {
    image: nook,
    price: '350',
    description: 'Nook staging set for 4 people'
  },
  officeSpace: {
    image: officeSpace,
    price: '550',
    description: 'Office space staging set'
  },
  outdoorDining: {
    image: outdoorDining,
    price: '350',
    description: 'Outdoor dining set'
  },
  outdoorLounge: {
    image: outdoorLounge,
    price: '350',
    description: 'Outdoor lounge set'
  }
}


// WEBPACK FOOTER //
// ./src/constants.js